export const composeAppleProviders = (allProviders = []) => {
  if (!allProviders?.length) {
    return null;
  }

  const appleProviders = allProviders?.filter((broadcaster) => {
    return (
      broadcaster?.broadcasterTypeLabel === "brd_type_international_streaming"
    );
  });

  if (appleProviders?.length) {
    return appleProviders;
  } else {
    return null;
  }
};
